// Runtime SEO injection for the SPA (Google renders JS; static crawlers get
// the prebuilt HTML from scripts/inject-seo.js).
const { SITE, ROUTES } = require("./seo-data");

function upsertMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href, hreflang) {
    const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
    let el = document.head.querySelector(sel);
    if (!el) {
        el = document.createElement("link");
        el.rel = rel;
        if (hreflang) el.setAttribute("hreflang", hreflang);
        document.head.appendChild(el);
    }
    el.href = href;
}

export function applySeo(path) {
    const r = ROUTES[path];
    if (!r) return false;
    const url = `${SITE}${path === "/" ? "/" : path}`;
    document.title = r.title;
    upsertMeta("name", "description", r.description);
    upsertMeta("name", "robots", "index, follow");
    upsertMeta("property", "og:title", r.ogTitle || r.title);
    upsertMeta("property", "og:description", r.ogDescription || r.description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:locale", r.locale || "en_MY");
    upsertLink("canonical", url);
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
    if (r.alt) {
        if (r.alt.en) upsertLink("alternate", `${SITE}${r.alt.en}`, "en");
        if (r.alt.cn) upsertLink("alternate", `${SITE}${r.alt.cn}`, "zh-CN");
        upsertLink("alternate", `${SITE}${r.alt.en || path}`, "x-default");
    }
    let ld = document.getElementById("route-jsonld");
    if (r.jsonLd) {
        if (!ld) {
            ld = document.createElement("script");
            ld.type = "application/ld+json";
            ld.id = "route-jsonld";
            document.head.appendChild(ld);
        }
        ld.textContent = JSON.stringify(r.jsonLd);
    } else if (ld) {
        ld.remove();
    }
    return true;
}
